class LazyScriptLoader {
  constructor() {
    this.scripts = [];
    this.selector = "script[data-loading=\"lazy\"][data-src]";
    this.interactionEvents = ["keydown", "touchstart", "click"];
    this.loadAfterMsIfNoInteraction = 5000;
    this.loadTimers = new Map();
    this.boundStartLoadingScripts = this.startLoadingScripts.bind(this);
    this.eventOptions = { passive: true };
  }


  init() {
    // find all scripts
    this.scripts = document.querySelectorAll(this.selector);

    // if there are no scripts, return
    if (this.scripts.length === 0) return;

    // load scripts on user interaction
    this.interactionEvents.forEach((event) => {
      document.addEventListener(event, this.boundStartLoadingScripts, this.eventOptions);
    });

    // Load each script after its own delay if the visitor does not interact.
    this.scripts.forEach((script) => {
      const configuredDelay = Number.parseInt(script.dataset.delay, 10);
      const delay = Number.isFinite(configuredDelay)
        ? configuredDelay
        : this.loadAfterMsIfNoInteraction;

      const timer = setTimeout(() => {
        this.loadScript(script);
        this.loadTimers.delete(script);
        this.removeInteractionListenersIfComplete();
      }, Math.max(0, delay));

      this.loadTimers.set(script, timer);
    });
  }

  startLoadingScripts() {
    if (this.allScriptsLoaded()) return;

    this.loadTimers.forEach((timer) => clearTimeout(timer));
    this.loadTimers.clear();

    this.loadScripts();
    this.removeInteractionListeners();
  }

  allScriptsLoaded() {
    return Array.from(this.scripts).every((script) => script.dataset.loading === "loaded");
  }

  removeInteractionListenersIfComplete() {
    if (!this.allScriptsLoaded()) return;
    this.removeInteractionListeners();
  }

  removeInteractionListeners() {
    this.interactionEvents.forEach((event) => {
      document.removeEventListener(event, this.boundStartLoadingScripts, this.eventOptions);
    });
  }

  loadScripts() {
    this.scripts.forEach((script) => {
      if (script.dataset.loading === "loaded") return;
      this.loadScript(script);
    });
  }

  loadScript(script) {
    script.dataset.loading = "loaded";
    script.src = script.dataset.src;
    script.removeAttribute("data-src");
  }
}

const loader = new LazyScriptLoader();
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", loader.init.bind(loader));
} else {
  loader.init();
}
